import { REALTIME_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const COUNTRY_REALTIME_REPORT_ID = `country${REALTIME_CAMPAIGN_SUFFIX}`;
